/** Nombre legible del SO a partir del user agent del navegador. */
export function resolveSistemaOperativo(userAgent?: string): string {
  const ua = userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '') ?? '';

  if (/windows phone/i.test(ua)) {
    return 'Windows Phone';
  }
  if (/android/i.test(ua)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(ua)) {
    return 'iOS';
  }
  if (/Win/i.test(ua)) {
    return 'Windows';
  }
  if (/Mac/i.test(ua)) {
    return 'MacOS';
  }
  if (/Linux/i.test(ua)) {
    return 'Linux';
  }

  return 'Desconocido';
}
